import { render, staticRenderFns } from "./Chatroom.vue?vue&type=template&id=3c9b5458&scoped=true&"
import script from "./Chatroom.vue?vue&type=script&lang=js&"
export * from "./Chatroom.vue?vue&type=script&lang=js&"
import style0 from "@/less/feedback.less?vue&type=style&index=0&id=3c9b5458&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9b5458",
  null
  
)

export default component.exports